import { SESSIONS_EN, SESSIONS_HI } from "../../content/activities";
import { t } from "../../i18n/dict";
import { Page } from "../../layout/Page";
import { Card } from "../../ui/Card";
import { Reveal } from "../../ui/Reveal";
import { Section } from "../../ui/Section";

/**
 * The old site's `/sessions`: "Past Sessions" as two columns, English and
 * Hindi, each a verbatim title/date/blurb plus its Facebook or YouTube
 * link, in the old carousel's own order. English only page chrome - the
 * old site had no Hindi rendering of this page itself (the Hindi column
 * is content, not translated chrome).
 */
export function SessionsPage() {
  return (
    <Page title="Sessions" heading="Sessions">
      <Section eyebrow="Past sessions" title="English">
        <div className="grid gap-6 sm:grid-cols-2">
          {SESSIONS_EN.map((entry) => (
            <Reveal key={entry.href}>
              <Card
                eyebrow={entry.date}
                title={entry.title}
                cta={{
                  label: t("en", "watchRecording"),
                  href: entry.href,
                  external: true,
                }}
              >
                <p>{entry.blurb}</p>
              </Card>
            </Reveal>
          ))}
        </div>
      </Section>
      <Section eyebrow="Past sessions" title="Hindi" tone="ivory-deep">
        <div className="grid gap-6 sm:grid-cols-2">
          {SESSIONS_HI.map((entry) => (
            <Reveal key={entry.href}>
              <Card
                eyebrow={entry.date}
                title={entry.title}
                cta={{
                  label: t("en", "watchRecording"),
                  href: entry.href,
                  external: true,
                }}
              >
                <p>{entry.blurb}</p>
              </Card>
            </Reveal>
          ))}
        </div>
      </Section>
    </Page>
  );
}
